import {createContext, useCallback, useContext} from "react";

const TextContext = createContext( /** @var {Record<string, string>} */{})

/**
 * @param {Record<string, string>} texts
 * @param {ReactNode} children
 * @returns {JSX.Element}
 */
export function TextProvider({ texts, children }) {
    return <TextContext.Provider value={texts}>{children}</TextContext.Provider>
}

export function useTranslations() {
    const texts = useContext(TextContext)
    return useCallback((key) => texts[key] ?? key, [texts])
}